export class Version {
  static readonly id = '4.3.66';
  static readonly experimental = false;
}
